import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "b-unavailabilities-card" }
const _hoisted_2 = { class: "b-unavailabilities-card__header" }
const _hoisted_3 = { class: "b-unavailabilities-card__title" }
const _hoisted_4 = {
  key: 0,
  class: "b-unavailabilities-card__wrapper"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwDatepicker = _resolveComponent("FwDatepicker")!
  const _component_UnavailabilityCard = _resolveComponent("UnavailabilityCard")!
  const _component_AddOrEditEventPopup = _resolveComponent("AddOrEditEventPopup")!
  const _component_DeletePopup = _resolveComponent("DeletePopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
      _createVNode(_component_FwDatepicker, {
        modelValue: _ctx.value,
        class: "b-unavailabilities-card__datepicker",
        name: "datepicker",
        placeholder: _ctx.title || _ctx.$t("CALENDAR.ALL.DATES"),
        propsRange: false,
        propsLang: _ctx.$i18n.locale || "en",
        popupStyle: { right: 0, left: "auto", },
        isCentered: true,
        pickerStyle: "sass-simple",
        onlyButtons: true,
        selectMode: true,
        iconName: "arrow-bottom",
        iconSize: "12",
        propsIconColor: "#213F6B",
        filteredSlotMenu: [1,5],
        translateSlotMenuTitles: _ctx.translateSlotMenuTitles,
        disabledDate: _ctx.disabledDateByObject,
        onSelectDate: _ctx.selectDateHandler,
        onAsRange: _ctx.asRangeHandler
      }, null, 8, ["modelValue", "placeholder", "propsLang", "translateSlotMenuTitles", "disabledDate", "onSelectDate", "onAsRange"])
    ]),
    (!_ctx.forceUpdating && _ctx.events && _ctx.events.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.events, (item) => {
            return (_openBlock(), _createBlock(_component_UnavailabilityCard, {
              key: item.id,
              item: item,
              onOpenEventPreview: _ctx.openEventPreview
            }, null, 8, ["item", "onOpenEventPreview"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPreview)
      ? (_openBlock(), _createBlock(_component_AddOrEditEventPopup, {
          key: 1,
          users: _ctx.userStore.users,
          loading: _ctx.loading,
          event: _ctx.addEventData,
          eventUserId: _ctx.user.id,
          showAvatar: false,
          originValue: `unavailability`,
          onOpenDeletePopup: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeletePopup = true)),
          onClose: _ctx.closePopup
        }, null, 8, ["users", "loading", "event", "eventUserId", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showDeletePopup)
      ? (_openBlock(), _createBlock(_component_DeletePopup, {
          key: 2,
          instance: _ctx.addEventData,
          isRequestSending: _ctx.isDeleteRequestSending,
          onRemoveEvent: _ctx.removeEvent,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDeletePopup = false))
        }, null, 8, ["instance", "isRequestSending", "onRemoveEvent"]))
      : _createCommentVNode("", true)
  ]))
}